var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpeReconcilliation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.79722 17.1417H13.2V15.3083H4.79722V17.1417ZM4.79722 11.9167H17.2028V10.0833H4.79722V11.9167ZM4.79722 6.69167H17.2028V4.85833H4.79722V6.69167ZM1.83333 22C1.34444 22 0.916667 21.8167 0.55 21.45C0.183333 21.0833 0 20.6556 0 20.1667V1.83333C0 1.34444 0.183333 0.916667 0.55 0.55C0.916667 0.183333 1.34444 0 1.83333 0H20.1667C20.6556 0 21.0833 0.183333 21.45 0.55C21.8167 0.916667 22 1.34444 22 1.83333V20.1667C22 20.6556 21.8167 21.0833 21.45 21.45C21.0833 21.8167 20.6556 22 20.1667 22H1.83333ZM1.83333 20.1667H20.1667V1.83333H1.83333V20.1667ZM1.83333 20.1667V1.83333V20.1667Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpeReconcilliation);
export default __webpack_public_path__ + "static/media/ppe_reconcilliation.8310a744d643972159b470a952a003ee.svg";
export { ForwardRef as ReactComponent };